import { SectionHeading } from '../components/SectionHeading';
import { ServiceCard } from '../components/ServiceCard';
import { services } from '../data/services';

export const ServicesGrid = () => (
  <section data-testid="services-section" className="bg-cream">
    <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-28">
      <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
        <SectionHeading
          chapter="02"
          eyebrow="Our Eight Core Services"
          title="Everything Your Business Needs to Grow Digitally."
          copy="Eight powerful solutions. One dedicated digital growth partner."
        />
      </div>
      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {services.map((s, i) => (
          <ServiceCard key={s.slug} service={s} index={i} large={i === 0 || i === 7} />
        ))}
      </div>
    </div>
  </section>
);
